import React, { Fragment, useEffect, useState } from "react";
import "../assets/scss/webinar.scss";
import { useHistory, useParams } from "react-router-dom";
import moment from "moment";
import { Button, Modal } from "antd";
import {
  askForumQuestionAutoService,
  getWebinarService,
  updateProgressService,
  userCouresEnrolService,
  webinarLiveAttenededService,
  webinarRegisterService,
} from "../services/oclive";
import { isMobile } from "react-device-detect";
import { PhoneFilled, RightOutlined } from "@ant-design/icons";
import ReactPlayer from "react-player";
import { AppLocalStorage, AppStorageKeys } from "../services/contracts";
import {
  isAuthenticated,
  isVideo,
  openNotificationInToast,
} from "../utilities";
import ExpertsCardsWebinar from "../components/ExpertsCardsWebinar";
import ComingSoonModal from "../components/ComingSoonModal";
import NeedHelpModal from "../components/NeedHelpModal";
import { INITIATE_AUTH_DRAWER } from "../actions/types";
import { useDispatch, useSelector } from "react-redux";
import AskAnExpert from "../components/AskAnExpert";
import ModalBox from "../components/ModalBox";
import ReadMore from "../components/ReadMore";
import PaymentModal from "../components/PaymentModal";
import { paymentOrderService } from "../components/razorpay/apis";
import { numberWithCommas } from "../sagas/utilities";
import Razorpay from "../components/razorpay/Razorpay";
import MetaDecorators from "../components/MetaDecorators";
import { SUPER_SIMPLE_AUTH_ORG_IDS } from "../services/environments.js";
import { getCustomSignUpFieldsService } from "../services/apiServices.js";
import CustomFieldsModalBox from "../components/common/CustomFieldsModalBox.js";
import { STREAMING_TYPE_ENUM } from "../contracts/index.js";

export const WEBINAR_JAM_REGISTRATION =
  "?first_name={firstName}&last_name={lastName}&email={email}&phone_country_code={phoneCountryCode}&phone_number={phoneNumber}&timezone={timeZone}&schedule_id=1";

function OClive(props) {
  const { domainDetails } = useSelector((state) => state.listings);
  const { chapterIdProps } = props;
  const { userDetails } = useSelector((state) => state.profile);
  const timeObj = {
    remDays: 0,
    remHours: 0,
    remMinutes: 0,
    remSeconds: 0,
  };
  const [isAskModalVisible, setAskModalVisible] = useState(false);
  const [webinarDetails, setWebinarDetails] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [time, setTime] = useState(timeObj);
  const [isLive, setIslive] = useState(false);
  const [openComingSoonModal, setOpenComingSoonModal] = useState(false);
  const [showBottomTimer, setShowBottomTimer] = useState(true);
  const [expertsToShow, setExpertsToShow] = useState([]);
  const [comingSoonAskExpTimeOut, setComingSoonAskExpTimeOut] = useState(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [webinarError, setWebinarError] = useState("");
  const [visibleWebinarErrorModal, setVisibleWebinarErrorModal] =
    useState(false);
  const [loading, setLoading] = useState(true);
  const [visiblePaymentProccedModal, setVisiblePaymentProccedModal] =
    useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [orderDetails, setOrderDetails] = useState({});
  const [openRazorpay, setOpenRazorpay] = useState(false);
  const [usersInfo, setUsersInfo] = useState({});
  const [buttonText, setButtonText] = useState("");
  const [customFields, setCustomFields] = useState([]);
  const [openCustomFieldsModal, setOpenCustomFieldsModal] = useState(false);
  const [customFieldsCaptured, setCustomFieldsCaptured] = useState(true);
  const [joinLink, setJoinLink] = useState("");

  const dispatch = useDispatch();
  const history = useHistory();
  let { webinarId } = useParams();

  let expertsToShowIndex = 0;

  if (!webinarId) {
    webinarId = chapterIdProps;
  }

  const isRegInit = localStorage.getItem("isRegInit");

  useEffect(() => {
    setVisibleWebinarErrorModal(false);
    fetchWebinarDetails();
  }, []);

  useEffect(() => {
    if (domainDetails.id && isAuthenticated()) {
      getCustomSignUpFieldsService(domainDetails.id)
        .then((response) => {
          if (response.fields?.length > 0) {
            setCustomFields(response.fields);
          }
          if (Object.keys(response).includes("isCaptured")) {
            setOpenCustomFieldsModal(!response.isCaptured);
            setCustomFieldsCaptured(response.isCaptured);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [domainDetails, isAuthenticated()]);

  useEffect(() => {
    let intervalId;
    if (
      webinarDetails &&
      webinarDetails.experts &&
      webinarDetails.experts.length > 0
    ) {
      calculateExpertsToShow();

      if (webinarDetails.experts.length > 3) {
        intervalId = setInterval(calculateExpertsToShow, 10000);
      }
    }
    if (webinarDetails && webinarDetails.cmeId) {
      AppLocalStorage.save(
        AppStorageKeys.registrationSourceCode,
        "webinar" + webinarDetails.cmeId + "oc" + webinarDetails.id
      );
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [webinarDetails]);

  useEffect(() => {
    const questionStr = localStorage.getItem("questionStr");
    if (userDetails && userDetails.users && userDetails.users.id) {
      if (
        isAuthenticated() &&
        questionStr &&
        webinarDetails &&
        webinarDetails.cmeId
      ) {
        postAskAnExpert(questionStr);
        localStorage.removeItem("questionStr");
        if (comingSoonAskExpTimeOut) {
          clearTimeout(comingSoonAskExpTimeOut);
        }
      }
      setUsersInfo({
        name: `${userDetails.users.firstName} ${userDetails.users.lastName}`,
        email: userDetails.users.email,
        contact: userDetails.users.mobileNumber,
      });
    }
  }, [userDetails, webinarDetails]);

  useEffect(() => {
    if (
      isAuthenticated() &&
      isRegInit &&
      webinarDetails &&
      userDetails &&
      userDetails.users &&
      (webinarDetails.hasWebinarHappened ||
        (!webinarDetails.hasWebinarHappened &&
          (time.remDays > 0 ||
            time.remHours > 0 ||
            time.remMinutes > 0 ||
            time.remSeconds > 0)))
    ) {
      if (webinarDetails.hasWebinarHappened) {
        setOpenComingSoonModal(false);
      } else {
        setOpenComingSoonModal(true);
      }
      if (checkForNonSimpleAuthOrgId()) {
        handleJoinNow();
      }
      localStorage.removeItem("isRegInit");
    }
  }, [time, webinarDetails, userDetails, isRegInit]);

  useEffect(() => {
    if (isLive && comingSoonAskExpTimeOut) {
      clearTimeout(comingSoonAskExpTimeOut);
    }
    if (!isLive && !isAskModalVisible) {
      setComingSoonAskExpTimeOut(
        setTimeout(() => {
          handleAskModalVisible();
        }, 7000)
      );
    }
  }, [isLive]);

  useEffect(() => {
    if (webinarDetails.isLive || isLive) {
      if (webinarDetails.isPaid && !webinarDetails.hasPaid) {
        setButtonText("Pay & Join");
      } else {
        setButtonText("Join");
      }
    } else {
      if (webinarDetails.isPaid && !webinarDetails.hasPaid) {
        setButtonText("Pay & Register");
      } else {
        setButtonText("Register");
      }
    }
  }, [webinarDetails, isLive]);

  const calculateExpertsToShow = () => {
    if (
      webinarDetails &&
      webinarDetails.experts &&
      webinarDetails.experts.length > 0
    ) {
      let oldIndex = expertsToShowIndex;
      let newIndex;
      if (oldIndex < webinarDetails.experts.length) {
        setExpertsToShow([]);
        setExpertsToShow(webinarDetails.experts.slice(oldIndex, oldIndex + 3));
        newIndex = oldIndex + 3;
      } else {
        setExpertsToShow([]);
        setExpertsToShow(webinarDetails.experts.slice(0, 3));
        newIndex = 3;
      }
      expertsToShowIndex = newIndex;
    }
  };

  const checkForNonSimpleAuthOrgId = () => {
    return !SUPER_SIMPLE_AUTH_ORG_IDS.includes(domainDetails.id);
  };

  const fetchWebinarDetails = () => {
    setLoading(true);
    getWebinarService(webinarId)
      .then((response) => {
        setWebinarDetails(response.webinar);
        getTimeCountDown(response.webinar.launchTime);
        if (response.webinar?.streamingType === STREAMING_TYPE_ENUM.YOUTUBE) {
          setJoinLink(
            `${window.location.origin}/stream/${response.webinar.chapterId}`
          );
        } else if (
          response.webinar?.streamingType === STREAMING_TYPE_ENUM.ZOOM ||
          response.webinar?.streamingType === STREAMING_TYPE_ENUM.EXTERNAL_LINK
        ) {
          setJoinLink(response.webinar.streamingSource);
        } else {
          setJoinLink(response.webinar.joinLink);
        }
        setLoading(false);
      })
      .catch((error) => {
        if (error && error.response && error.response.data) {
          setWebinarError(error.response.data);
          setVisibleWebinarErrorModal(true);
          setLoading(false);
        }
      });
  };

  let countDownTimer;
  const getTimeCountDown = (date) => {
    countDownTimer = setInterval(() => setTimeInCountDown(date), 1000);
  };

  const setTimeInCountDown = (date) => {
    const countryTimeZoneName = webinarDetails.countryTimeZone
      ? webinarDetails.countryTimeZone.name
      : moment.tz.guess() !== undefined
      ? moment.tz.guess()
      : "Asia/Kolkata";
    let now = moment.tz(countryTimeZoneName);
    let countDownDate = moment.tz(date, countryTimeZoneName);
    let timeleft = countDownDate.diff(now);

    if (timeleft >= 0) {
      const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
      setTime({
        ...time,
        remDays: days,
        remHours: hours,
        remMinutes: minutes,
        remSeconds: seconds,
      });
      if (days === 0 && hours === 0 && minutes < 10) {
        setIslive(true);
      }
    } else {
      clearInterval(countDownTimer);
      setIslive(true);
    }
  };

  const returnTime = (timeData, text) => {
    return (
      <div className={"timeContainer"}>
        <div className={"text"}>{text}</div>
        <div className={"number"}>{timeData}</div>
      </div>
    );
  };

  const getCountDownTimer = () => {
    return (
      <div className={"ocLiveLaunchInfo"}>
        <div className={"countdownTimer"}>
          {returnTime(time.remDays, "DAYS")}
          {returnTime(time.remHours, "HOURS")}
          {returnTime(time.remMinutes, "MINUTES")}
          {returnTime(time.remSeconds, "SECONDS")}
        </div>
      </div>
    );
  };

  const handlePaymentSucceedModal = () => {
    setVisiblePaymentProccedModal(false);
    const payload = {
      type: "WEBINAR",
      widgetId: webinarId,
      widgetType: "CME",
    };
    fetchPaymentOrderDetails(payload);
  };

  const fetchPaymentOrderDetails = (payload) => {
    paymentOrderService(payload)
      .then((response) => {
        setPaymentDetails(response.orderDetail);
        setOrderDetails(payload);
        setOpenRazorpay(true);
      })
      .catch((error) => {
        Modal.error({
          title: "Something went wrong. Please try again!",
          onOk() {},
        });
      });
  };

  const handleJoinNow = () => {
    if (comingSoonAskExpTimeOut) {
      clearTimeout(comingSoonAskExpTimeOut);
    }
    if (isAuthenticated()) {
      if (webinarDetails.isPaid && !webinarDetails.hasPaid) {
        setVisiblePaymentProccedModal(true);
      } else {
        if (!customFieldsCaptured) {
          setOpenCustomFieldsModal(true);
        } else {
          webinarRegister();
        }
      }
    }
  };

  const webinarRegister = () => {
    const payload = { webinarId: webinarId };
    webinarRegisterService(payload)
      .then((response) => {
        if (time.remDays >= 0 && time.remHours >= 0 && time.remMinutes > 11) {
          setOpenComingSoonModal(true);
        } else {
          updateProgress();
        }
        if (!webinarDetails.hasRegistered) {
          window.location.reload();
        }
      })
      .catch((error) => {
        if (time.remDays >= 0 && time.remHours >= 0 && time.remMinutes > 11) {
          setOpenComingSoonModal(true);
        } else {
          updateProgress();
        }
      });
  };

  const updateProgress = () => {
    if (time.remDays === 0 && time.remHours === 0 && time.remMinutes <= 10) {
      let payload = {
        accessToken: isAuthenticated(),
        duration: "1",
        isBubbleUp: true,
        courseId: webinarDetails.cmeId,
        isCompleted: false,
        status: 1,
        lastViewPoint: 0,
        widgetId: webinarId,
        widgetType: "CHAPTER",
      };
      updateProgressService(payload)
        .then((response) => {
          redirectToYoutubeOrWebinarJam();
        })
        .catch((error) => redirectToYoutubeOrWebinarJam());
    } else {
      redirectToYoutubeOrWebinarJam();
    }
  };

  const redirectToYoutubeOrWebinarJam = () => {
    if (joinLink.includes("webinarjam")) {
      if (userDetails && userDetails.users) {
        if (webinarDetails.hasWebinarHappened) {
          openUrl(webinarDetails.redirectUrl);
        } else if (joinLink.indexOf("event.webinarjam.com/") !== -1) {
          let phoneCountryCode =
            "+" + webinarDetails.countryTimeZone.country.phoneCode;
          let timeZone = webinarDetails.countryTimeZone.timeCoordinated;
          let webinarJamUrl =
            joinLink.replace("register", "register/1click") +
            WEBINAR_JAM_REGISTRATION.replace(
              "{firstName}",
              userDetails.users.firstName
            )
              .replace("{lastName}", userDetails.users.lastName)
              .replace("{email}", userDetails.users.email)
              .replace("{phoneCountryCode}", phoneCountryCode)
              .replace("{phoneNumber}", userDetails.users.mobileNumber)
              .replace("{timeZone}", timeZone);
          webinarLiveAtteneded(webinarJamUrl);
        }
      }
    } else if (joinLink.includes("/stream/") || joinLink.includes("zoom")) {
      if (time.remDays === 0 && time.remHours === 0 && time.remMinutes <= 10) {
        webinarLiveAtteneded(joinLink);
      } else {
        setOpenComingSoonModal(true);
      }
    }
  };

  const webinarLiveAtteneded = (url) => {
    const payload = { webinarId: webinarId };
    webinarLiveAttenededService(payload)
      .then((response) => {
        openUrl(url);
      })
      .catch((error) => openUrl(url));
  };

  const openUrl = (url) => {
    if (!webinarDetails.redirectWebinarBack) {
      window.open(url, "_self");
    } else {
      window.open(webinarDetails.webinarLandingUrl, "_self");
    }
  };

  const handleRegisterNow = () => {
    if (comingSoonAskExpTimeOut) {
      clearTimeout(comingSoonAskExpTimeOut);
    }
    dispatch({
      type: INITIATE_AUTH_DRAWER,
    });
    localStorage.setItem("isRegInit", true);
  };

  const postAskAnExpert = (query) => {
    if (webinarDetails && webinarDetails.isPaid && !webinarDetails.hasPaid) {
      setAskModalVisible(false);
      localStorage.setItem("questionStr", query);
      setVisiblePaymentProccedModal(true);
    } else {
      handleJoinNow();
      const expertId =
        webinarDetails.experts &&
        webinarDetails.experts.length > 0 &&
        webinarDetails.experts[0].id;
      const payload = {
        accessToken: isAuthenticated(),
        expertId: expertId,
        chapterId: parseInt(webinarId),
        question: query,
        sendSms: true,
        autoAssign: true,
      };
      postQuestion(askForumQuestionAutoService, payload);
    }
  };

  const handleClosePaymentProccedModal = () => {
    setVisiblePaymentProccedModal(false);
    localStorage.removeItem("questionStr");
  };

  const postQuestion = (service, payload) => {
    service(payload)
      .then((response) => {
        setAskModalVisible(false);
        openNotificationInToast(
          "success",
          "Success!",
          "Thank you for submitting the question. It will be answered in the Q&A session of the webinar!"
        );
        localStorage.removeItem("questionStr");
      })
      .catch((error) => {
        openNotificationInToast("error", "Failed!", "Something went wrong!");
        localStorage.removeItem("questionStr");
      });
  };

  const closeComingSoonModal = (value) => {
    setOpenComingSoonModal(value);
    localStorage.removeItem("isRegInit");
  };

  const getMobileView = () => {
    return (
      <div className={"mobileWebinar"}>
        <ComingSoonModal
          visible={openComingSoonModal}
          setVisible={closeComingSoonModal}
        />
        <NeedHelpModal
          isWebinar={true}
          visible={isModalVisible}
          setVisible={setIsModalVisible}
        />
        <AskAnExpert
          visible={isAskModalVisible}
          setVisible={setAskModalVisible}
          postAskAnExpert={postAskAnExpert}
        />
        <div>
          <button className={"askButton"} onClick={handleAskModalVisible}>
            Post Your Questions
          </button>
        </div>
        <div>
          <button
            className={"helpButton"}
            onClick={() => setIsModalVisible(true)}
          >
            <PhoneFilled style={{ transform: "scaleX(-1)" }} />
          </button>
        </div>
        {!loading && (
          <div className={"ocliveTimer"}>
            <div style={{ fontWeight: "bold" }}>GOES LIVE IN</div>
            {getCountDownTimer()}
            <div className={"liveTime"}>
              {moment(webinarDetails.launchTime).format("Do, MMMM YYYY, dddd")}
              <br />
              {moment(webinarDetails.launchTime).format("h:mm A")}
            </div>
          </div>
        )}
        <div>
          {webinarDetails.webinarImage &&
          isVideo(webinarDetails.webinarImage) ? (
            <ReactPlayer
              className={"webinarBannerVideoContainer"}
              url={webinarDetails.webinarImage}
              muted={true}
              playing={isPlaying}
              controls={true}
              playsinline={true}
              light={webinarDetails.webinarThumbnail}
              width="100%"
              height="100%"
            />
          ) : (
            <img
              className={"webinarIntroImage"}
              src={
                isMobile
                  ? webinarDetails.webinarImage
                  : webinarDetails.webWebinarImage
                  ? webinarDetails.webWebinarImage
                  : webinarDetails.webinarImage
              }
            />
          )}
        </div>
        <div style={{ textAlign: "center", marginTop: "3vh" }}>
          <button
            onClick={() =>
              !isAuthenticated() ? handleRegisterNow() : handleJoinNow()
            }
            className={"pulseButtonMobile"}
          >
            {/* {webinarDetails.isLive || isLive ? 'Join Now' : 'Register Now'} */}
            {webinarDetails.buttonTitle}
          </button>
        </div>
        <div style={{ padding: 15 }}>
          <div className={"topicName"}>{webinarDetails.topicName}</div>
          <div className={"webinarDescription"}>
            <ReadMore
              className={"ocLiveDescription"}
              content={webinarDetails.description}
              showAsHTML={true}
            />
          </div>
        </div>
        <div className={"expertCardsContainer"}>
          {expertsToShow &&
            expertsToShow.length > 0 &&
            expertsToShow.map((items, index) => {
              return (
                <ExpertsCardsWebinar
                  key={index}
                  id={items.id}
                  name={items.name}
                  profilePic={items.profilePic}
                  qualifications={items.qualification}
                  bio={items.shortBio}
                />
              );
            })}
        </div>
      </div>
    );
  };

  const enrollAndRegister = () => {
    if (isAuthenticated() && webinarDetails && webinarDetails.cmeId) {
      const userId = userDetails.users && userDetails.users.id;
      let payload = {
        userId: userId,
        repCode: "webinar" + webinarDetails.cmeId,
        courseId: webinarDetails.cmeId,
      };
      userCouresEnrolService(payload).then().catch();
      const payloadResister = { webinarId: webinarId };
      webinarRegisterService(payloadResister).then().catch();
    }
  };

  const handleAskModalVisible = () => {
    // enrollAndRegister();
    setAskModalVisible(true);
  };

  const bottomTimer = () => {
    return (
      <div className={"bottomTimer"}>
        <div className={"dateFlex"}>
          <div className={"ocLiveDate"}>
            {moment(webinarDetails.launchTime).format("Do")}
          </div>
          <div>
            <div className={"liveTime"}>
              {moment(webinarDetails.launchTime).format("MMMM YYYY,")}
            </div>
            <div className={"liveTime"}>
              {moment(webinarDetails.launchTime).format("dddd h:mm A")}
            </div>
          </div>
        </div>

        <div className={"actionFlex"}>
          {getCountDownTimer()}
          <div>
            <button
              onClick={() =>
                !isAuthenticated() ? handleRegisterNow() : handleJoinNow()
              }
              className={"pulseButton"}
            >
              {/* {webinarDetails.isLive || isLive ? 'Join Now' : 'Register Now'} */}
              {webinarDetails.buttonTitle}
            </button>
          </div>
          <div>
            <button className={"askButton"} onClick={handleAskModalVisible}>
              Post Your Questions
            </button>
          </div>
          <div>
            <button
              className={"askButton"}
              onClick={() => setIsModalVisible(true)}
            >
              Need Help{" "}
              <span>
                <PhoneFilled style={{ transform: "scaleX(-1)" }} />
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  };

  const handleGoBack = () => {
    setVisibleWebinarErrorModal(false);
    history.goBack();
  };

  return (
    <Fragment>
      <MetaDecorators />
      {webinarError !== "" ? (
        <ModalBox
          title=""
          visible={visibleWebinarErrorModal}
          setVisible={handleGoBack}
          className="webinarErrorModal"
          width="400px"
          centered={false}
        >
          <h1>{webinarError}</h1>
          <Button type="primary" onClick={handleGoBack}>
            Go Back
          </Button>
        </ModalBox>
      ) : isMobile ? (
        getMobileView()
      ) : (
        <div className={"ocLiveContainer"}>
          <div className={"joinWebinarContainer"}>
            <div
              className={"webinarMediaBox"}
              style={{
                height:
                  domainDetails.orgType === "certifier"
                    ? "calc(100vh - 262px)"
                    : "calc(100vh - 198px)",
              }}
            >
              {webinarDetails.webinarImage &&
              isVideo(webinarDetails.webinarImage) ? (
                <ReactPlayer
                  className={"webinarBannerVideoContainer"}
                  url={webinarDetails.webinarImage}
                  muted={true}
                  playing={isPlaying}
                  playsinline={true}
                  controls={true}
                  light={webinarDetails.webinarThumbnail}
                  width="100%"
                  height="100%"
                />
              ) : (
                <img
                  className={"webinarIntroImage"}
                  src={
                    isMobile
                      ? webinarDetails.webinarImage
                      : webinarDetails.webWebinarImage
                      ? webinarDetails.webWebinarImage
                      : webinarDetails.webinarImage
                  }
                  alt={webinarDetails.topicName}
                />
              )}
            </div>
            {!loading && (
              <div
                className={`timeCount ${
                  webinarId === "23805" ? "bg-color-blue" : ""
                }`}
                style={
                  !showBottomTimer ? { transform: "translateY(95px)" } : {}
                }
              >
                {bottomTimer()}
              </div>
            )}
          </div>
          <ComingSoonModal
            visible={openComingSoonModal}
            setVisible={closeComingSoonModal}
          />
          <NeedHelpModal
            isWebinar={true}
            visible={isModalVisible}
            setVisible={setIsModalVisible}
          />
          <AskAnExpert
            visible={isAskModalVisible}
            setVisible={setAskModalVisible}
            postAskAnExpert={postAskAnExpert}
          />
        </div>
      )}
      <PaymentModal
        modalTitle="Paid Webinar"
        visible={visiblePaymentProccedModal}
        setVisible={handleClosePaymentProccedModal}
        status="procceed"
        buttonTitle="Proceed to payment"
        buttonIcon={<RightOutlined />}
        buttonAction={handlePaymentSucceedModal}
      >
        <p>
          This is a paid webinar, and costs{" "}
          <span className="paymentAmount">
            {webinarDetails.countryCode === "IN" ? (
              <span>&#8377;</span>
            ) : (
              <span>&#x24;</span>
            )}
            {numberWithCommas(webinarDetails.webinarAmount)}*
          </span>
          . Please proceed to pay to get access when webinar goes live.
        </p>
        <div className="paymentCharge">{webinarDetails.paymentDisclaimer}</div>
      </PaymentModal>
      <CustomFieldsModalBox
        customFields={customFields}
        open={openCustomFieldsModal}
        setCustomFieldsCaptured={setCustomFieldsCaptured}
        orgId={domainDetails.id}
        setOpen={setOpenCustomFieldsModal}
        webinarRegister={webinarRegister}
      />
      <Razorpay
        amount={paymentDetails.amount}
        orderId={paymentDetails.orderId}
        currency={paymentDetails.currencyType}
        description="Webinar"
        orderDetails={orderDetails}
        usersInfo={usersInfo}
        openRazorpay={openRazorpay}
        launchTime={webinarDetails.launchTime}
        isLive={webinarDetails.isLive || isLive}
        setOpenRazorpay={setOpenRazorpay}
        onPaymentSuccess={enrollAndRegister}
      />
    </Fragment>
  );
}

export default OClive;
